module.exports = __webpack_public_path__ + "img/legal_now_normal.99566578.svg";